// src/features/business-functions/components/workspace-detail/WorkspaceZeroState.jsx
import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import AddIcon from '@mui/icons-material/Add';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import { CAMPAIGN_COPY } from '../../constants/campaignCopy';

/**
 * Scenario A Guided Onboarding Banner — shown when tables.length === 0.
 * Explains how creating a form/table enables overview analytics and workspace reporting.
 */
export default function WorkspaceZeroState({ styles, onCreateClick, canCreateTable = false }) {
  return (
    <Box sx={styles.zeroStateCard}>
      <Paper
        elevation={0}
        sx={{
          width: 64,
          height: 64,
          borderRadius: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'success.light',
          color: 'success.dark',
          mb: 1,
        }}
      >
        <TableChartOutlinedIcon sx={{ fontSize: 36 }} />
      </Paper>

      <Typography sx={styles.zeroStateTitle}>
        {canCreateTable
          ? 'Create your first table or form to get started'
          : CAMPAIGN_COPY.detail.zeroStateNoTables}
      </Typography>

      <Typography sx={styles.zeroStateSubtitle}>
        {canCreateTable
          ? 'Once you create a campaign form or custom table, collected data will automatically populate the overview analytics, charts, and activity feeds.'
          : CAMPAIGN_COPY.detail.zeroStateViewOnly}
      </Typography>

      {/* Guided 3 Steps — only when user can create */}
      {canCreateTable ? (
        <Box
          sx={{
            display: 'flex',
            gap: 3,
            my: 2,
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <DescriptionOutlinedIcon color="action" fontSize="small" />
            <Typography variant="body2" color="text.secondary">
              1. Build Form / Table
            </Typography>
          </Box>
          <Typography variant="body2" color="text.disabled">→</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <TableChartOutlinedIcon color="action" fontSize="small" />
            <Typography variant="body2" color="text.secondary">
              2. Collect Records
            </Typography>
          </Box>
          <Typography variant="body2" color="text.disabled">→</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <BarChartOutlinedIcon color="action" fontSize="small" />
            <Typography variant="body2" color="text.secondary">
              3. View Reports & Automations
            </Typography>
          </Box>
        </Box>
      ) : null}

      {canCreateTable ? (
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => onCreateClick?.('table')}
          sx={styles.zeroStateCtaBtn}
          disableElevation
        >
          + Create First Form / Table
        </Button>
      ) : null}
    </Box>
  );
}
